import { useAuthentication } from '@gripp/shared-logic';
import { AnonymousShareView } from '../../anonymous/anonymousShareView';
import { ProtectedRoute } from '../../auth/components/protectedRoute';

/**
 * `/share/:token` resolver entry, the way `/:tagId` decides between the
 * ordinary and the anonymous asset view. Signed in: the usual ProtectedRoute
 * → Layout → ShareView (via Outlet) path, untouched. Signed out: the
 * self-contained anonymous view. Both render in place — the URL has to stay
 * on the token so the share header keeps flowing on the conversation reads.
 */
export const ShareEntry = () => {
  const authentication = useAuthentication();

  if (!authentication || authentication.isLoading) {
    return null;
  }

  return authentication.isAuthenticated ? (
    <ProtectedRoute />
  ) : (
    <AnonymousShareView />
  );
};
